export const deployedChains = [1, 42, 1337];
